import { API_LOAN_GET_MERS, API_LOAN_GET_MERS_BY_KEY } from 'config'
import Api from 'services/api'

export const getMers = () => {
  return Api.get(API_LOAN_GET_MERS)
}

export const updateMers = (key: string, value: any) => {
  return Api.put(API_LOAN_GET_MERS_BY_KEY, { value }, { key })
}

export const getMersLogs = (key: string) => {
  return Api.get(API_LOAN_GET_MERS_BY_KEY, { key }, { key: 'log' })
}

